// The frosted surface floating chrome shares: the bottom nav pill, the banners
// above it and the map overlays. Heavy blur keeps busy photos behind it legible.
export const glassSurfaceClass =
  'border border-border/60 bg-card/55 backdrop-blur-2xl backdrop-saturate-150 shadow-lg shadow-background/30'

// The nav pill and the banners stacked above it. `chrome-hit` makes the
// surface tappable inside the click-through BottomChrome.
export const navPillClass = `chrome-hit ${glassSurfaceClass}`

// The floating action chips' denser take on the glass: they sit over the schedule's
// photo cards, where the nav's lighter fill let them blend into the grid.
export const fabGlassClass =
  'border border-foreground/20 bg-card/80 backdrop-blur-2xl backdrop-saturate-150 shadow-lg shadow-background/80'
